import { ComponentMultiStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import { MenuProps } from './Menu';

import getElevation, { ElevationSizes } from 'theme/elevations';
import SEMANTIC_TOKENS from 'theme/semanticTokens';
import { getFocusedOutlineShadow } from 'theme/shadows';

const MenuTheme: ComponentMultiStyleConfig = {
  parts: ['button', 'divider', 'groupTitle', 'list', 'item'],
  baseStyle: (props: MenuProps & StyleFunctionProps) => ({
    button: {
      transistionProperty: 'none',
      _focus: {},
      _focusVisible: {
        boxShadow: getFocusedOutlineShadow(props)
      },
      span: {
        flex: 'none',
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    },
    divider: {
      color: mode('silver.base', 'grey.base')(props),
      marginTop: '0.5rem',
      marginBottom: '0.5rem'
    },
    groupTitle: {
      textTransform: 'uppercase',
      fontSize: '10px',
      fontWeight: '600',
      letterSpacing: '0.8px',
      margin: '0 8px 0 8px',
      paddingTop: '0.4rem',
      paddingBottom: '0.4rem',
      paddingInlineStart: '8px',
      paddingInlineEnd: '8px'
    },
    list: {
      boxShadow: getElevation(props, ElevationSizes.md),
      border: '0',
      borderRadius: '12px',
      bg: mode('silver.lightest', 'black.lightest')(props),
      color: mode('black.lighter', 'silver.light')(props),
      overflowY: props.height ? 'scroll' : 'auto',
      height: props.height ? props.height : 'auto'
    },
    item: {
      _active: {
        bg: 'blue.base',
        color: 'silver.lightest'
      },
      _focus: {
        bg: 'blue.base',
        color: 'silver.lightest'
      },
      transistionProperty: 'none',
      fontSize: '14px',
      borderRadius: '8px',
      width: '284px',
      minHeight: '32px',
      lineHeight: '15px',
      margin: '0 8px 0 8px',
      paddingInlineStart: '8px',
      paddingInlineEnd: '8px',
      transitionProperty: 'none',
      transitionDuration: 'inherit',
      transitionTimingFunction: 'inherit',

      ...(props.colorScheme === 'destructive' && {
        color: SEMANTIC_TOKENS.colors.destructive.default,
        _dark: {
          color: SEMANTIC_TOKENS.colors.destructive._dark
        },
        _hover: {
          color: 'silver.lightest',
          backgroundColor: SEMANTIC_TOKENS.colors.destructive.default,
          _dark: {
            color: 'silver.lightest'
          }
        },
        _focus: {
          color: 'silver.lightest',
          backgroundColor: SEMANTIC_TOKENS.colors.destructive.default,
          _dark: {
            color: 'silver.lightest'
          }
        },
        _active: {
          color: 'silver.lightest',
          backgroundColor: SEMANTIC_TOKENS.colors.destructive.default,
          _dark: {
            color: 'silver.lightest'
          }
        }
      })
    }
  })
};

export default MenuTheme;
